import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {
        backgroundColor: 'transparent',
    },
    secondaryBackground: {
        backgroundColor: theme.palette.secondary.main,
    },
    actHealthBackground: {
        backgroundColor: theme.palette.actHealth.main,
    },
    contentWrapper: {
        height: 56,
        [theme.breakpoints.up('sm')]: {
            height: 64,
        },
    },
    backButtonWrapper: {
        paddingLeft: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            paddingLeft: theme.spacing(2),
        },
    },
    roleBackgroundWrapper: {
        height: '100%',
        width: 450,
        [theme.breakpoints.down('sm')]: {
            width: 300,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
}));
